module.exports = __webpack_public_path__ + "static/media/defaultuser.fc7e33e5.png";